import { createRoot } from "react-dom/client";
import "./index.css";
import AppRouter from "./routes/Routes.jsx";
import CommonContextProvider from "./context/commonContext.jsx";
import { Provider } from "react-redux";
import { store } from "./store/store.js";
import { pdfjs } from "react-pdf";
import Notify from "./components/Notify/Notify";

import pdfjsWorker from "pdfjs-dist/build/pdf.worker.min.mjs?url";
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <CommonContextProvider>
      <AppRouter />
      <Notify />
    </CommonContextProvider>
  </Provider>
);